import { createSlice } from '@reduxjs/toolkit';

import { setState } from '@app/helpers/store';

const subsidiariesSlice = createSlice({
  name: 'subsidiaries',
  initialState: {
    isFetching: false,
    // Whether a fetch attempt has finished, regardless of outcome — check
    // `error` separately to know whether `list` reflects real data.
    hasCompleted: false,
    list: [],
    error: null,
  },
  reducers: {
    fetchSubsidiariesRequest(state) {
      setState(state, { isFetching: true, hasCompleted: false, error: null });
    },
    fetchSubsidiariesSuccess(
      state,
      {
        payload: { list },
      },
    ) {
      setState(state, {
        isFetching: false,
        hasCompleted: true,
        list: list || [],
      });
    },
    fetchSubsidiariesError(
      state,
      {
        payload: { error },
      },
    ) {
      setState(state, { isFetching: false, hasCompleted: true, error });
    },
  },
});

const { actions, reducer } = subsidiariesSlice;

export const {
  fetchSubsidiariesRequest,
  fetchSubsidiariesSuccess,
  fetchSubsidiariesError,
} = actions;

export default reducer;
